import { render, staticRenderFns } from "./LoginGuidance.vue?vue&type=template&id=6a5131ba&scoped=true"
import script from "./LoginGuidance.vue?vue&type=script&lang=js"
export * from "./LoginGuidance.vue?vue&type=script&lang=js"
import style0 from "./LoginGuidance.vue?vue&type=style&index=0&id=6a5131ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5131ba",
  null
  
)

export default component.exports